export default __webpack_public_path__ + "static/media/1.fddd3a92.svg";